import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  '@keyframes pulse': {
    '0%, 100%': { transform: 'scale(1)', opacity: 1 },
    '50%': { transform: 'scale(1.6)', opacity: 0.45 },
  },
  '@keyframes rise': {
    from: { opacity: 0, transform: 'translateY(10px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  '@keyframes glow': {
    '0%, 100%': { opacity: 0.05 },
    '50%': { opacity: 0.12 },
  },
  root: {
    position: 'fixed',
    inset: 0,
    backgroundColor: '#F6F2EC',
    backgroundImage:
      'radial-gradient(circle at 20% 12%, rgba(31,29,27,0.06), transparent 45%), radial-gradient(circle at 82% 88%, rgba(31,29,27,0.06), transparent 50%)',
    color: '#1F1D1B',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: theme.zIndex.modal + 100,
    padding: theme.spacing(4),
    overflow: 'hidden',
  },
  ambientGlow: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 520,
    height: 520,
    marginTop: -260,
    marginLeft: -260,
    borderRadius: '50%',
    backgroundImage:
      'radial-gradient(circle, rgba(31,29,27,0.18), transparent 60%)',
    animation: '$glow 4.5s ease-in-out infinite',
    pointerEvents: 'none',
  },
  stack: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(3.5),
  },
  spinnerWrap: {
    position: 'relative',
    width: 96,
    height: 96,
    animation: '$rise 700ms ease-out both',
  },
  spinner: {
    width: 96,
    height: 96,
    color: '#1F1D1B',
    display: 'block',
  },
  guide: {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 0.7,
    opacity: 0.16,
  },
  arcGroup: {
    transformOrigin: '50px 50px',
    animation: '$spin 1.5s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite',
  },
  arc: {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round',
    strokeDasharray: '78 251',
    strokeDashoffset: 0,
  },
  dotGroup: {
    transformOrigin: '50px 50px',
    animation: '$pulse 1.5s ease-in-out infinite',
  },
  dot: {
    fill: 'currentColor',
  },
  rule: {
    width: 32,
    height: 1,
    backgroundColor: '#1F1D1B',
    opacity: 0.4,
    animation: '$rise 800ms 200ms ease-out both',
  },
  label: {
    fontFamily: 'Raleway, sans-serif',
    fontWeight: 600,
    fontSize: 13,
    letterSpacing: '0.42em',
    paddingLeft: '0.42em',
    color: '#1F1D1B',
    textAlign: 'center',
    animation: '$rise 800ms 280ms ease-out both',
  },
  message: {
    fontFamily: 'Raleway, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    letterSpacing: '0.01em',
    color: '#7A7368',
    maxWidth: 320,
    textAlign: 'center',
    lineHeight: 1.6,
    animation: '$rise 900ms 380ms ease-out both',
  },
}))

export default useStyles
